import { render, staticRenderFns } from "./AiSaveToKnowledgeButton.vue?vue&type=template&id=27f7e9a4&scoped=true"
import script from "./AiSaveToKnowledgeButton.vue?vue&type=script&lang=js"
export * from "./AiSaveToKnowledgeButton.vue?vue&type=script&lang=js"
import style0 from "./AiSaveToKnowledgeButton.vue?vue&type=style&index=0&id=27f7e9a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f7e9a4",
  null
  
)

export default component.exports